export const searchOptions = [
  {
    value: "depot",
    title: "Depot",
  },
  {
    value: "serialNumber",
    title: "Serial Number",
  },
];
